module.exports = __webpack_public_path__ + "static/media/1.f82c5838.webp";